jQuery(function ($) {
  var $footer = $(".wt-footer");

  $(window).on("scroll resize", function () {
    var scrollPos = $(window).scrollTop() + $(window).height();
    var docHeight = $(document).height();

    if (scrollPos >= docHeight - 5) {
      $footer.addClass("active");
    } else {
      $footer.removeClass("active");
    }
  });
});
